import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { currencyFormat, formatDate, numberFormat } from '../../utility/Helpers'

const InteractorCsvShipping = () => {
  const { t } = useTranslation()

  const csvShipping = useCallback(
    (data, callback) => {
      const headers = [
        { label: 'No', key: 'no' },
        { label: t('title.purchase_request_number'), key: 'transaction_code' },
        { label: t('title.shipping_date_sent'), key: 'shipping_date_sent' },
        { label: t('title.shipping_date_delivered'), key: 'shipping_date_delivered' },
        { label: t('title.shipping_code'), key: 'shipping_code' },
        { label: t('title.shipping_number'), key: 'shipping_number' },
        { label: t('title.note'), key: 'shipping_note' },
        { label: t('title.bill.status'), key: 'initial_status' },
        { label: t('title.bill.invoice_code'), key: 'bill_code' },
        { label: t('title.bill_status'), key: 'bill_status' },
        { label: t('title.product.product_name'), key: 'product_title' },
        { label: t('title.product.product_total'), key: 'product_quantity' },
        { label: t('title.product.price'), key: 'product_price_item' },
        { label: t('title.subtotal_product'), key: 'subtotal_product' },
      ]

      // MAPPING ROW
      let results = []

      data?.forEach((row, idx) => {
        if (row.shipping_items && row.shipping_items?.length > 0) {
          row?.shipping_items?.forEach((item, key) => {
            if (item) {
              const isFirstRow = key === 0
              const subtotal = item.product_price_item * item.product_quantity
              const obj = {
                no: isFirstRow ? idx + 1 : '',
                transaction_code: isFirstRow ? row.transaction_code : '',
                shipping_date_sent: isFirstRow
                  ? formatDate(row.shipping_date_sent, 'DD/MM/YYYY HH:mm')
                  : '',
                shipping_date_delivered: isFirstRow
                  ? formatDate(row.shipping_date_delivered, 'DD/MM/YYYY HH:mm')
                  : '',
                shipping_code: isFirstRow ? row.shipping_code : '',
                shipping_number: isFirstRow ? row.shipping_number : '',
                shipping_note: isFirstRow ? row.shipping_note : '',
                initial_status: isFirstRow ? t(`initial_status.${row.initial_status}`) : '',
                bill_code: isFirstRow ? row.bill_code : '',
                bill_status: isFirstRow
                  ? t(`status.shipping_bill_status.${row.bill_status.toLowerCase()}`)
                  : t(`status.shipping_bill_status.${row.bill_status.toLowerCase()}`) || '',
                product_title: item.product_title,
                product_quantity: numberFormat(item.product_quantity),
                product_price_item: currencyFormat(
                  item.product_price_item,
                  item.product_price_currency,
                ),
                subtotal_product:
                  subtotal !== 0 ? currencyFormat(subtotal, item.product_price_currency) : 0,
              }
              results.push(obj)
            }
          })
        }
      })
      callback({
        headers,
        data: results,
        filename: 'SHIPPING-' + new Date().getTime() + '.csv',
      })
    },
    [t],
  )

  return { csvShipping }
}

export default InteractorCsvShipping
